import React, { useEffect, useState } from "react";
import { Redirect } from 'react-router-dom';
import { useAuth } from "../../hooks/AuthContext";
import { DefaultLoginForm } from "./Form/DefaultLoginForm";
import { TwoFactorAuthForm } from "./Form/TwoFactorAuthForm";
import { PasswordResetForm } from "./Form/PasswordResetForm";

import './login.css'

type Props = {};

function Login(props: Props) {
  const [newPasswordRequired , setNewPasswordRequired] = useState(false);
  const [resetPasswordByInactive , setResetPasswordByInactive] = useState(false);
  const [resetPasswordByTime , setResetPasswordByTime] = useState(false);
  const [twoFactorAuth , setTwoFactorAuth] = useState(false);
  const [needCreateTwoFactorAuth , setNeedCreateTwoFactorAuth] = useState(false);

  const { store } = useAuth();

  useEffect(() => {
    if (
      !!store &&
      store.id === undefined &&
      (
        store.twoFactorAuthentication ||
        store.newPasswordRequired ||
        store.needCreateTwoFactorAuth
      )
    ) {
      setNewPasswordRequired(store.newPasswordRequired!);
      setResetPasswordByInactive(store.resetPasswordByInactive!);
      setResetPasswordByTime(store.resetPasswordByTime!);
      setTwoFactorAuth(store.twoFactorAuthentication!);
      setNeedCreateTwoFactorAuth(store.needCreateTwoFactorAuth!);
    }
  }, [store]);

  // SE FOR REQUERIDO UMA NOVA SENHA - SECURITY 3 MESES
  if (newPasswordRequired) {
    // RESET BY INATIVIDADE || EACH 3 MONTH
    if (resetPasswordByInactive || resetPasswordByTime) {
      return <Redirect to="/reset-password" />
    }

    return <PasswordResetForm />;
  }

  if (needCreateTwoFactorAuth === true) {
    return <Redirect to="/configure-two-factors" />
  }

  if (twoFactorAuth) {
    return <TwoFactorAuthForm />
  }

  return <DefaultLoginForm />;
}

export default Login;